import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { PcmsoCreateRequest, PcmsoRequest, PcmsoUpdateRequest } from '@/core/api/sicom-api/registro/medico/pcmso/pcmso.model';
import { PcmsoService } from '@/core/api/sicom-api/registro/medico/pcmso/pcmso.service';
import { RiscoPcmsoService } from '@/core/api/sicom-api/registro/medico/risco-pcmso/risco-pcmso.service';
import { RiscoPcmsoResponse } from '@/core/api/sicom-api/registro/medico/risco-pcmso/risco-pcmso.model';
import { PageResponse } from '@/core/api/sicom-api/sistema/usuario/usuario.model';
import { HttpContext } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
/** Fachada de PCMSO: busca por aba, criar/editar, riscos e anexos. */
export class PcmsoFeatureService extends CustomService {
    private readonly core = inject(PcmsoService);
    private readonly riscoCore = inject(RiscoPcmsoService);

    buscar(params: Pessoa & { page?: number; size?: number }): Observable<PageResponse<PcmsoRequest>> {
        return this.core.buscar(params).pipe(catchError(this.handleError));
    }

    buscarInativo(params: Pessoa & { page?: number; size?: number }): Observable<PageResponse<PcmsoRequest>> {
        return this.core.buscarInativo(params).pipe(catchError(this.handleError));
    }

    listarRiscos(): Observable<RiscoPcmsoResponse[]> {
        return this.riscoCore.listar().pipe(catchError(this.handleError));
    }

    criar(payload: PcmsoCreateRequest, context?: HttpContext): Observable<PcmsoRequest> {
        return this.core.criar(payload, context).pipe(catchError(this.handleError));
    }

    uploadDocumento(file: File): Observable<number> {
        return this.core.uploadDocumento(file).pipe(catchError(this.handleError));
    }

    downloadAnexo(params: { uf: string; idMedico: number; nuRegistro: number | string }): Observable<Blob> {
        return this.core.downloadAnexo(params).pipe(catchError(this.handleError));
    }

    uploadAnexoRegistro(params: { uf: string; idMedico: number; nuRegistro: number | string }, file: File): Observable<void> {
        return this.core.uploadAnexoRegistro(params, file).pipe(catchError(this.handleError));
    }

    editar(params: { uf: string; idMedico: number | string; nuRegistro: number | string }, payload: PcmsoUpdateRequest): Observable<void> {
        return this.core.editar(params, payload).pipe(catchError(this.handleError));
    }
}
